import React from 'react';
import { Placeholder, Text } from '@sitecore-jss/sitecore-jss-react';
import ReplaceableText from '../../../utils/text/ReplaceableText/index';
import { connect, useDispatch } from 'react-redux';
import {
  updateProductCode,
  updateSelectedQuote,
  updateToCoverText,
} from '../../../redux/slices/quoteDataSlice';
import { useInternalNavigate } from '../../../utils/navigate/useNavigate';
import { pushEvent, resolveEvent } from '../../../utils/analytics/datalayer';
import renderToCoverValue from '../../../utils/prospectData/renderToCoverValue';

const QuoteSummary = ({ rendering, fields, quote, quoteData, nextPage }) => {
  const dispatch = useDispatch();
  const navigate = useInternalNavigate();

  const raiseDatalayerEvent = () => {
    const event = resolveEvent(fields.datalayerEvent?.value, quote);
    pushEvent(event);
  };

  let datalayerEvent = {};
  try {
    datalayerEvent = fields.datalayerEvent?.value ? JSON.parse(fields.datalayerEvent.value) : {};
  } catch {}

  const handleClick = () => {
    raiseDatalayerEvent();
    dispatch(updateProductCode(quote.productCode));

    const item = datalayerEvent?.ecommerce?.items?.[0] || {};
    const coverStartDateOffset = fields.coverStartDateOffset?.value;
    const itemName = item.item_name || '';
    const itemId = item.item_id || '';

    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate() + coverStartDateOffset);
    const day = String(currentDate.getDate()).padStart(2, '0');
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const year = currentDate.getFullYear();
    const formattedDate = `${day}/${month}/${year}`;
    const selectedQuote = {
      ...quote,
      coverStartDate: formattedDate,
      itemName,
      itemId,
      productName: getProductName(itemName, fields),
    };

    dispatch(updateSelectedQuote(selectedQuote));
    dispatch(updateToCoverText(renderToCoverValue(quoteData)));

    if (nextPage) {
      navigate(nextPage);
    }
  };

  return (
    <div className="vds-grid__column vds-grid__column--sm-6">
      <div className="vds-multi-quote-details" data-testid={`${fields.testid?.value}-card`}>
        <div className="vds-multi-quote-details__inner">
          <div className="vds-multi-quote-details__main">
            <div className="vds-multi-quote-details__header">
              <Text tag="h2" className="vds-multi-quote-details__heading" field={fields.heading} />
            </div>
            <div className="vds-multi-quote-details__body">
              <div className="vds-icon-listing">
                <div className="vds-icon-listing__inner">
                  <ul className="vds-icon-listing__list">
                    <Placeholder name="quoteSummary-checklist" rendering={rendering} />
                  </ul>
                </div>
              </div>
            </div>

            <div className="vds-multi-quote-details__quote">
              <h3 className="vds-multi-quote-details__quote-primary">
                <ReplaceableText
                  tag="strong"
                  field={fields.perMonth}
                  obj={quote}
                  isCurrency={true}
                />
              </h3>

              <h4 className="vds-multi-quote-details__quote-secondary">
                <ReplaceableText
                  tag="strong"
                  field={fields.perYear}
                  obj={quote}
                  isCurrency={true}
                />
              </h4>

              <p className="vds-multi-quote-details__supporting">
                <Text field={fields.quoteReference} />
                <strong>{quote?.healthQuoteNumber}</strong>
              </p>
            </div>
          </div>

          <div className="vds-multi-quote-details__footer">
            <a
              className="vds-button vds-button--fluid"
              data-testid={`${fields.testid?.value}-cta`}
              onClick={handleClick}
              href="#"
            >
              <Text field={fields.ctaText} /> <i className="fa-solid fa-chevron-right" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

const getProductName = function (itemName, fields) {
  if (fields?.concatHeading?.value) {
    return itemName + ' ' + fields?.heading?.value;
  }
  return fields?.heading?.value;
};

const mapStateToProps = (state, props) => {
  const productCode = props.fields.productCode?.value;
  let quote = undefined;
  if (productCode) {
    quote = state.quoteResponse.quoteDetails.find(q => q.productCode === productCode);
  }
  return {
    ...props,
    quote,
    nextPage: state.appState.nextPage,
    quoteData: state.quoteData,
  };
};
export default connect(mapStateToProps)(QuoteSummary);
